import { TUseEntityMenuReturn } from 'contexts/app-context/types'

export const USE_ENTITY_MENU_RETURN_DEFAULT_OBJ: TUseEntityMenuReturn = {
  title: '',
  content: {
    headerSection: {
      title: '',
      icon: '',
      infoBottomsheet: {
        title: '',
        content: [],
        confirmButton: '',
      },
    },
    menuSection: [],
    entityTransactionSection: {
      BR: {
        icon: '',
        title: '',
        details: '',
        footnote: '',
      },
      US_BRANCH: {
        icon: '',
        title: '',
        details: '',
        footnote: '',
      },
    },
    unavailableFeature: {
      title: '',
      details: '',
      icon: '',
      type: 'gray',
      email: '',
      button: '',
    },
    blockedAccounts: [],
  },
  rightIcon: {
    iconRef: '',
    color: '',
    size: 24,
    onClick: () => null,
  },
  showBottomsheet: false,
  entities: [],
  traceDetails: '',
  isLoading: false,
  isError: false,
  bottomsheetClickHandler: () => null,
}
